import dayjs from 'dayjs'
import { Select, Tooltip } from 'antd'
import { Icon } from '@iconify/react'

import NoProfile from '../../../assets/images/no_profile.png'
import { JOB_APPLICATIONS_STATUS } from '../../../constants/jobs'
import styles from '../jobApplications.module.css'

const getYear = (value) => {
    if (!value) return null
    const year = dayjs(value).year()
    return Number.isFinite(year) ? year : null
}

const formatExperienceRange = (experience) => {
    if (!experience) return null

    const company = experience?.company?.name
    const startYear = getYear(experience?.startDate)
    const endYear = experience?.currentlyWorking
        ? 'Present'
        : getYear(experience?.endDate)

    const rangeParts = []
    if (startYear) rangeParts.push(startYear)
    if (endYear) rangeParts.push(endYear)
    const range = rangeParts.length ? `(${rangeParts.join(' - ')})` : null

    if (company && range) return `${company} ${range}`
    if (company) return company
    if (range) return range
    return null
}

const formatAvailableFrom = (value) => {
    if (!value) return '—'
    const parsed = dayjs(value)
    if (parsed.isValid()) return parsed.format('DD MMM YYYY')
    return String(value)
}

const JobApplicantInfoCard = ({
    state,
    handleUpdateJobApplicationStatus,
    handleViewNotes,
}) => {
    const applicant = state?.selectedApplicantData
    const candidate = applicant?.candidate
    const designation = candidate?.designation?.name
    const experienceLine = formatExperienceRange(candidate?.experience?.[0])
    const institute = candidate?.education?.[0]?.institute?.name

    const subtitleParts = [experienceLine, institute].filter(Boolean)
    const phone = candidate?.primaryContactNumber
        ? `${candidate?.primaryContactNumberCountryCode || ''} ${
              candidate.primaryContactNumber
          }`.trim()
        : null

    return (
        <div className={styles.infoCard}>
            <div className={styles.infoCardBody}>
                <div className={styles.infoCardLeft}>
                    <img
                        src={applicant?.profilePicture || NoProfile}
                        alt=""
                        className={styles.infoAvatar}
                    />

                    <div className={styles.infoMain}>
                        <h3 className={styles.infoName}>
                            {applicant?.fullName || '—'}
                            {designation ? (
                                <span className={styles.infoDesignation}>
                                    {' '}
                                    ({designation})
                                </span>
                            ) : null}
                        </h3>

                        {subtitleParts.length > 0 ? (
                            <p className={styles.infoSub}>
                                {subtitleParts.join(' • ')}
                            </p>
                        ) : null}

                        {(candidate?.address || phone) && (
                            <div className={styles.infoChips}>
                                {candidate?.address ? (
                                    <span className={styles.infoChip}>
                                        <Icon
                                            icon="mdi:map-marker-outline"
                                            width={14}
                                            height={14}
                                        />
                                        {candidate.address}
                                    </span>
                                ) : null}
                                {phone ? (
                                    <span className={styles.infoChip}>
                                        <Icon
                                            icon="mdi:phone-outline"
                                            width={14}
                                            height={14}
                                        />
                                        {phone}
                                    </span>
                                ) : null}
                            </div>
                        )}
                    </div>
                </div>

                <div className={styles.infoCardRight}>
                    <div className={styles.infoActions}>
                        {handleViewNotes ? (
                            <Tooltip title="View Notes">
                                <button
                                    type="button"
                                    className={styles.notesBtn}
                                    onClick={handleViewNotes}
                                    aria-label="View Notes"
                                >
                                    <Icon
                                        icon="mdi:note-text-outline"
                                        width={18}
                                        height={18}
                                    />
                                </button>
                            </Tooltip>
                        ) : null}

                        {handleUpdateJobApplicationStatus ? (
                            <Select
                                placeholder="Select a Status"
                                onChange={handleUpdateJobApplicationStatus}
                                className={`${styles.statusSelect} recruitStatusSelect`}
                                value={applicant?.applicationStatus}
                                options={JOB_APPLICATIONS_STATUS}
                            />
                        ) : null}
                    </div>

                    <div className={styles.infoMetaBlock}>
                        <div className={styles.salaryRow}>
                            <span className={styles.salaryLabel}>Expected</span>
                            <span className={styles.salaryValue}>
                                ${candidate?.expectedSalary || 0}
                            </span>
                            <span className={styles.salaryType}>
                                / {candidate?.expectedSalaryType || '—'}
                            </span>
                        </div>

                        <div className={styles.availableFrom}>
                            <span>Available From :</span>
                            <span className={styles.availableFromValue}>
                                {formatAvailableFrom(candidate?.availableFrom)}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JobApplicantInfoCard
